import { useState } from "react";

const useSummaryDetail = () => {
    const [open, setOpen] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);

    const [pagination, setPagination] = useState({page: 0, limit: 5, total: 0});

    const dummyData = Array.from({ length: 5 }, (_, index) => ({
        id: index + 1,
        consignee_name: `Consignee ${index + 1}`,
        po_number: `PO-${index + 1}`,
        booking_no: `Booking-${index + 1}`,
        reference_no: `Ref-${index + 1}`,
        etd_vessel: `Vessel-${index + 1}`,
        eta_end_destination: `Destination-${index + 1}`,
        pol: `POL-${index + 1}`,
        pod: `POD-${index + 1}`,
        last_activities_status: `Status-${index + 1}`,
        last_activities_time: new Date().toISOString(),
    }));
    const [dataGrid, setDataGrid] = useState<any>(dummyData);
    const [dataItem, setDataItem] = useState<any>({
        id: '',
    });


    return {
        data: {
           open,
           dataItem,
           dataGrid,
           pagination,
           deleteOpen,
        },
        method:
        {
            setOpen,
            setDataItem,
            setDataGrid,
            setPagination,
            setDeleteOpen,
        }
    };
}

export { useSummaryDetail };
